import { DataVersion, LocationAlarmsDTO } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useLocationAlarms(
  searchParams: string,
  refetchInterval: number,
  onSuccess?: (data: LocationAlarmsDTO) => void,
  disabled = false,
  keepPreviousData = false,
  // v2/v3 read override. Only `v3` goes on the wire, as the `X-Data-Version`
  // header (gated in withDataVersion); the backend honors it for every
  // authenticated user. `v2`/`undefined`/`null` send no header and get
  // per-tenant routing.
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/location_alarms?${searchParams}`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<LocationAlarmsDTO>(request, {
    // dataVersion is part of the key so flipping the toggle refetches.
    queryKey: ['locationAlarms', { searchParams, dataVersion }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval,
    refetchIntervalInBackground: true,
    onSuccess,
    enabled: !disabled,
    keepPreviousData,
  });
}

export default useLocationAlarms;
